import React from "react";

import { useModalContext } from "./Modal";

import { THEME_BASE } from "~/styles/theme";

export default function Footer({ children, styles }: { children: React.ReactNode; styles?: React.CSSProperties }) {
  useModalContext();

  const defaultStyle = {
    padding: "12px 24px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
    backgroundColor: THEME_BASE.colors.lightGray,
  };

  return <footer style={{ ...defaultStyle, ...styles }}>{children}</footer>;
}
